import { render, staticRenderFns } from "./AlarmHistory.vue?vue&type=template&id=8be1bb2e&scoped=true&"
import script from "./AlarmHistory.vue?vue&type=script&lang=js&"
export * from "./AlarmHistory.vue?vue&type=script&lang=js&"
import style0 from "./AlarmHistory.vue?vue&type=style&index=0&id=8be1bb2e&lang=scss&scoped=true&"
import style1 from "./AlarmHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1bb2e",
  null
  
)

export default component.exports